import { LocalNotifications } from '@capacitor/local-notifications';
import { isNative } from './api';

export async function scheduleCallReminder(id, scheduledTime) {
  if (!isNative) return false;
  const at = new Date(scheduledTime);
  if (!Number.isFinite(at.getTime()) || at.getTime() <= Date.now()) {
    throw new Error('Choose a future time for this call');
  }
  let permission = await LocalNotifications.checkPermissions();
  if (permission.display !== 'granted') permission = await LocalNotifications.requestPermissions();
  if (permission.display !== 'granted') return false;

  await LocalNotifications.schedule({
    notifications: [{
      id: Number(id),
      title: 'Santa is calling!',
      body: 'Open North Pole Line to answer.',
      schedule: { at },
      extra: { scheduledCallId: Number(id) }
    }]
  });
  return true;
}

export async function cancelCallReminder(id) {
  if (!isNative) return;
  await LocalNotifications.cancel({ notifications: [{ id: Number(id) }] });
}

export async function listenForCallReminders(onCall) {
  if (!isNative) return null;
  return LocalNotifications.addListener('localNotificationActionPerformed', action => {
    const id = Number(action.notification?.extra?.scheduledCallId);
    if (Number.isSafeInteger(id) && id > 0) onCall(id);
  });
}
